const fathersArray = ['fathersLastName', 'fathersFirstName', 'fathersMiddleName']
const mothersArray = ['mothersLastName', 'mothersFirstName', 'mothersMiddleName']
const nickNameArray = ['nickLastName', 'nickFirstName', 'nickMiddleName']
const representativeNameArray = ["representativeTitleOnName", "representativeLastName", "representativeFirstName", "representativeMiddleName"]
const representativeAddressArray = ["representativeAddressFlat", "representativeAddressRoad", "representativeAddressArea", "representativeAddressVillage", "representativeAddressPincode", "representativeAddressCity", "representativeAddressState", "representativeAddressCountry"]
const officeAddressArray = ["officeAddressBuilding", "officeAddressFlat", "officeAddressVillage", "officeAddressRoad", "officeAddressArea", "officeAddressPincode", "officeAddressCity", "officeAddressState", "officeAddressCountry"]

export const removeFreshNotRequired = (formValues) => {

    if (formValues.parentsName === "fathersName") {
        mothersArray.map((motherName) => {
            formValues[motherName] = ""
        })
    }

    

    if (formValues.parentsName === "mothersName" && formValues.singleParent === "yes") {
        fathersArray.map((fatherName) => {
            formValues[fatherName] = ""
        })
    }

    

    if (formValues.isNickName === false) {
        nickNameArray.map((nickName) => {
            formValues[nickName] = ""
        })
    }

    if(formValues.aadhaarCard == "yes"){
        formValues.aadhaarEnrollNumber = ""
        formValues.aadhaarEnroll = ""
    }
    else{
        formValues.aadhaarNumber = ""
        formValues.aadhaarName = ""
    }

    if (formValues.isRepresentativeAssessee === false) {
        representativeNameArray.map((repName) => {
            formValues[repName] = ""
        })

        representativeAddressArray.map((repAddress) => {
            formValues[repAddress] = ""
        })
    }
    

    if(!["incomeFromBusinessProfession", "salary"].includes(formValues["incomeSource"])){
        formValues.businessType = ""
    }
    

    if(!(formValues["isOfficeAddressDelivery"] === true || ["incomeFromBusinessProfession", "salary"].includes(formValues["incomeSource"]))){
        officeAddressArray.map((officeAddress)=>{
            formValues[officeAddress] = ""
        })
    }
    

    if(!(formValues["isOfficeAddressDelivery"] === true || formValues["incomeSource"] === "salary")){
        formValues.individualProofOffice = ""
    }

    return formValues;

}